import { VOZIDLO_CDB } from '@/modules/kartoteka/vozidlo/constants';

export { DMS_MODULE } from '../../constants';

export const NAME = VOZIDLO_CDB;
export const CRUMB_LABEL_KEY = 'cmdVozidlaCdb';
